export const references = [
    {
        text: "PKD International: What is ADPKD?. Retrieved March 04, 2021.",
        href: "https://pkdinternational.org/what-is-pkd/adpkd",
    },
    {
        text: "National Kidney Foundation: Polycystic kidney disease. Retrieved March 04, 2021.",
        href: "https://www.kidney.org/atoz/content/polycystic",
    },
    {
        text: "智友站-慢性腎衰竭. 醫院管理局. (2021). Retrieved June 08, 2021.",
        href: "https://www21.ha.org.hk/smartpatient/SPW/zh-hk/Disease-Information/Disease/?guid=368b30e4-cc1c-4185-b673-7dfb3ea8f74b",
    },
    {
        text: "How Your Kidneys Work. National Kidney Foundation. (2021). Retrieved June 08, 2021.",
        href: "https://www.kidney.org/atoz/content/howkidneyswork",
    }, {
        text: "Oxford Kidney Unit: Autosomal Dominant Polycystic Kidney Disease. Retrieved March 04, 2021.",
        href: "from https://www.ouh.nhs.uk/patient-guide/leaflets/files/29168Pautosomal.pdf",
    }, {
        text: "UCSF Health: Polycystic kidney disease, Autosomal dominant. Retrieved March 04, 2021.",
        href: "https://www.ucsfhealth.org/conditions/polycystic-kidney-disease-autosomal-dominant",
    }, {
        text: "PKD Foundation: What are the stages of ADPKD. Retrieved March 05, 2021.",
        href: "https://pkdcure.org/what-is-adpkd/what-are-the-stages-of-adpkd/",
    },
    {
        text: "Hossack KF, et al.Echocardiographic findings in autosomal dominant polycystic kidney disease.N.Engl.J.Med. 1988; 319: 907–912.",
    },
    {
        text: "Bremmer, M. (2010).Polycystic kidney disease: inheritance, pathophysiology, prognosis, and treatment.International Journal of Nephrology and Renovascular Disease, 69.",
        href: "https://doi.org/10.2147/ijnrd.s6939",
    },
    {
        text: "Srivastava, A., & Patel, N. (2014).Autosomal dominant polycystic kidney disease.American family physician, 90(5), 303–307.",
    },
];
